var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('HSCodeEditAdmin',{attrs:{"HSCode":_vm.HSCode,"serverError":_vm.serverError},on:{"editHSGroup":_vm.editHSGroup}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }